import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import TwitterIcon from '@material-ui/icons/Twitter'
import FacebookIcon from '@material-ui/icons/Facebook'
import InstagramIcon from '@material-ui/icons/Instagram'
import IconButton from '@material-ui/core/IconButton'

const useStyles = makeStyles(() => ({
  iconButton: {
    marginRight: 10,
    padding: 0
  },
  icon: {
    height: 18,
    width: 18
  },
  label: {
    fontSize: '16px',
    paddingBottom: 4
  },
  mobileLabel: {
    fontSize: '12px',
    paddingBottom: 3
  },
  mobileIcon: {
    height: 15,
    width: 15
  }
}))

function AgentName (props) {
  const conversationLabel = props.conversationLabel

  return (
    <>
      <div style={{ color: props.color }}>{conversationLabel}</div>
    </>
  )
}

export default AgentName
